import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemBoards: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-boards',
		defaultMessage: 'Board settings',
		description: 'Board configuration link item.',
	},
	itemBoardColumns: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-columns',
		defaultMessage: 'Columns and statuses',
		description: 'Board columns and statuses link item.',
	},
	itemBoardCustomFilters: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-custom-filters',
		defaultMessage: 'Custom filters',
		description: 'Custom filters link item.',
	},
	itemBoardDetails: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-details',
		defaultMessage: 'General',
		description: 'Sidebar link to navigate to general board settings.',
	},
	itemBoardCard: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-card',
		defaultMessage: 'Card cover images',
		description: 'Sidebar link to configure the card layout of a board.',
	},
	itemBoardTimeline: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-timeline',
		defaultMessage: 'Timeline',
		description: 'Sidebar link to configure the settings of a timeline.',
	},
	itemBoardSwimlanes: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-swimlanes',
		defaultMessage: 'Swimlanes',
		description: 'Sidebar link to configure the swimlanes for a board.',
	},
	itemBoardFeatures: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-features',
		defaultMessage: 'Board features',
		description: 'Sidebar link to configure the features enabled for a board.',
	},
	itemBoardInsightsNonfinal: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.board.item-board-insights-nonfinal',
		defaultMessage: 'Insights',
		description: 'Sidebar link to configure the insights.',
	},
});
